const { abstractResource } = require('./abstractResource')

const service = abstractResource('TICKETS')

const Answer = {
    ...service('answers'),
    get_form() {
        return {
            author: null,
            description: null,
            link: null,
            ticket: null,
            recipient: null,
            recipients_cc: [],
            recipients_cci: [],
            is_external: false,
        }
    }
}

const Reference = {
    ...service('references'),
    get_form() {
        return {
            name: null,
            reference: null,
        }
    }
}

const Contract = {
    ...service('contracts'),
    get_form() {
        return {
            name: null,
            number: null,
            type: null,
            status: null,
            status_renewal: null,
            licence_type: null,
            licence_key: null,
            service_provider: null,
            reference: null,
            renewal: null,
            send_notif: null,
            send_approval: null,
            approval_accept: null,
            description: null,
            end_date: null,
            start_date: null,
            created_at: null,
            cost: null,
            refused_reason: null,
        }
    },
    get_type_choices() {
        return [
            {text: 'Lease', value: 'lease'},
            {text: 'Maintenance', value: 'maintenance'},
            {text: 'Software licence', value: 'licence'},
        ]
    },

    get_licence_type_choice() {
        return [
            {text: 'Gratuit', value: 'free'},
            {text: 'Open source', value: 'open'},
            {text: 'Évaluation', value: 'evaluation'},
            {text: 'Entreprise', value: 'business'},
            {text: 'Volume', value: 'volume'},
        ]
    },
    get_billing_cycle_choice() {
        return [
            {value: "monthly", text: "Mensuelle"},
            {value: "Quarterly", text: "Trimestrielle"},
            {value: "Half-yearly", text: "Semestrielle"},
            {value: "Annual", text: "Annuelle"},
            {value: "one_time", text: "En une fois"}
        ]
    },

    get_status_choices() {
        return [
            {value: "drafts", text: "Brouillon"},
            {value: "waiting", text: "En attente d’approbation"},
            {value: "active", text: "Activé"},
            {value: "cancel", text: "Résilié"},
            {value: "refuse", text: "Refusé"},
            {value: "expired", text: "Expiré"},
        ]
    },
    get_status_renewal_choices() {
        return [
            {value: "ask_renewal", text: "Demande de renouvellement"},
            {value: "renewed", text: "Renouvelé"},
            {value: "renewel_refused", text: "Renouvellement refusé"},
            {value: "extension_refused", text: "Prolongement refusé"},
        ]
    },

}

const Category = {
    ...service('categories'),
    get_form() {
        return {
            name: null,
            reference: null,
        }
    }
}

const CategoryQuestion = {
    ...service('category-questions'),
    get_form() {
        return {
            name: null,
            reference: null,
        }
    }
}

const Charge = {
    ...service('charges'),
    get_form() {
        return {
            date: null,
            description: null,
            price: null,
            tool: null,
            type: null,
        }
    },

    get_type_choices() {
        return [
            {value: 'maintenance', text: 'Coût de maintenance'},
            {value: 'support', text: 'Coût de support'},
            {value: 'elimination', text: "Coût d'élimination"},
            {value: 'other', text: 'Autre'}
        ]
    }
}

const Component = {
    ...service('components'),
    get_form() {
        return {
            active_dhcp: null,
            adress_IP: null,
            adress_MAC: null,
            capacity: null,
            category: null,
            core_by_socket: null,
            core_number: null,
            default_bridge: null,
            disk_type: null,
            file_type: null,
            free_space: null,
            hyperthread: null,
            location: null,
            logical_core: null,
            manufacturer: null,
            memory_type: null,
            model: null,
            mounting_point: null,
            name: null,
            network: null,
            nic: null,
            rpm: null,
            server_dhcp: null,
            socket: null,
            speed: null,
            subnet_mask: null,
            tag_module: null,
            tool: [],
            type: null
        }
    },

    get_category_choices() {
        return [
            {value: 'processor', text: 'Processeur'},
            {value: 'memory', text: 'Mémoire'},
            {value: 'network_adapter', text: 'Adaptateur réseau'},
            {value: 'hard_disk', text: 'Disque dur'},
            {value: 'logical_disk', text: 'Disque logique'},
            {value: 'data_repository', text: 'Dépôt de données'}
        ]
    }
}

const Cost = {
    ...service('costs'),
    get_form() {
        return {
            price: null,
        }
    }
}

const CostItem = {
    ...service('cost-items'),
    get_form() {
        return {
            license: null,
        }
    }
}

const License = {
    ...service('licenses'),
    get_form() {
        return {
            name: null,
            number: null,
            provider: [],
            status: null,
            price: null,
            approver: [],
        }
    },

    get_status_choices() {
        return [
            {text: 'Actif', value: 'active'},
            {text: 'Désactivé', value: 'disable'},
        ]
    }
}

const Note = {
    ...service('notes'),
    get_form() {
        return {
            description: null,
            ticket: null,
        }
    }
}

const Question = {
    ...service('questions'),
    get_form() {
        return {
            closed: null,
            deadline: null,
            element: null,
            impact: null,
            last_modification: null,
            ticket: null,
            urgent: null,
        }
    },

    get_impacts_choices() {
        return [
            {text: 'Faible', value: 'low'},
            {text: 'Moyenne', value: 'medium'},
            {text: 'Élevée', value: 'hight'},
        ]
    },

    get_urgences_choices() {
        return [
            {text: 'Faible', value: 'low'},
            {text: 'Moyenne', value: 'average'},
            {text: 'Élevée', value: 'hight'},
        ]
    }
}

const Sla = {
    ...service('sla'),
    get_form() {
        return {
            description: null,
            name: null,
            clients: [],
            types: [],
            situation: null,
            tickets_concerned: 'all',
        }
    },
    get_situation_choices(){
        return [
            {text: 'Externe', value: 'external'},
            {text: 'Interne', value: 'internal'},
        ]
    }
}

const SlaAnswerRule = {
    ...service('sla-answer-rules'),
    get_form() {
        return {
            destinataire: null,
            hierarchy: null,
            name: null,
        }
    }
}

const SlaEmailAlert = {
    ...service('sla-email-alerts'),
    get_form(type = null) {
        return {
            users: [],
            type: type,
            time: type,
            duration: null,
            sla: null,
        }
    },

    get_duration_choices() {
        return [
            {value: '0,5_hour', text: '...30 minutes'},
            {value: '1_hour', text: '...1 heure'},
            {value: '2_hour', text: '...2 heures'},
            {value: '4_hour', text: '...4 heures'},
            {value: '8_hour', text: '...8 heures'},
            {value: '12_hour', text: '...12 heures'},
            {value: '1_day', text: '...1 jour'},
            {value: '2_day', text: '...2 jours'},
            {value: '3_day', text: '...3 jours'},
            {value: '1_week', text: '...1 semaine'},
            {value: '2_week', text: '...2 semaines'},
            {value: '1_month', text: '...1 mois'},
        ]
    },

    get_time_choices() {
        return [
            {value: 'before', text: '...avant...'},
            {value: 'after', text: '...après...'},
        ]
    }
}

const SlaResolutionRule = {
    ...service('sla-resolution-rules'),
    get_form() {
        return {
            name: null,
            recipient: null,
            rule_level: null,
        }
    }
}

const SlaRule = {
    ...service('sla-rules'),
    get_form() {
        return {
          priority: null,
          considered_time: null,
          considered_unit: null,
          response_delay_time: null,
          response_delay_unit: null,
          response_resolution_time: null,
          response_resolution_unit: null,
          account_hours: null,
        }
    },

    get_priorities_choices() {
        return [
            {text: 'Faible', value: 'low', color: 'success'},
            {text: 'Moyenne', value: 'average', color: 'warning'},
            {text: 'Élevée', value: 'high', color: 'primary'},
            {text: 'Urgence', value: 'emergency', color: 'danger'},
        ]
    },

    get_hours_choices() {
      return [
        {text: 'Heures ouvrées', value: 'open'},
        {text: 'Heures calendaires', value: 'calendar'},
      ]
    },

    get_units_choices() {
      return [
        {text: 'minutes', value: 'minutes'},
        {text: 'heures', value: 'hours'},
        {text: 'jours', value: 'days'},
        {text: 'semaines', value: 'weeks'},
        {text: 'mois', value: 'months'},
      ]
    }
}

const SlaTicketDelayRule = {
    ...service('sla-ticket-delay-rules'),
    get_form() {
        return {
            emails: null,
            hierarchy: null,
            recipient: null,
            rule_level: null,
            sla: null,
        }
    }
}

const SlaTicketRule = {
    ...service('sla-ticket-rules'),
    get_form() {
        return {
            condition: null,
            field: null,
            sla: null,
            value: null,
        }
    },

    get_condition_choices() {
      return [
        {text: 'Est', value: 'is'},
        {text: 'N\'est pas ', value: 'is_not'},
        {text: 'Contient', value: 'have'},
        {text: 'Ne contient pas', value: 'have_not'},
        {text: 'Commence par', value: 'begin_by'},
        {text: 'Termine par', value: 'end_by'},
        {text: 'Est vide', value: 'empty'},
        {text: 'N\'est pas vide', value: 'empty_not'},
      ]
    },

    get_fields_choices() {
      return [
        {text: 'Objet', value: 'object'},
        {text: 'Type', value: 'type'},
        {text: 'Source', value: 'source'},
        {text: 'Urgence', value: 'urgence'},
        {text: 'Impact', value: 'impact'},
        {text: 'Équipe', value: 'team'},
        {text: 'Collaborateur', value: 'collaborator'},
        {text: 'Département', value: 'departmenr'},
        {text: 'Catégorie d\'outil', value: 'category'},
        {text: 'Sous-catégorie', value: 'subcategory'},
        {text: 'Élément', value: 'element'},
      ]
    },
}

const Software = {
    ...service('softwares'),
    get_form() {
        return {
            category: null,
            editors: null,
            installations: null,
            managed_by: null,
            name: null,
            status: null,
            type: null,
            users: null,
        }
    },

    get_status_choices() {
        return [
            {text: 'Désactivé', value: 'disabled'},
            {text: 'Actif', value: 'active'},
            {text: 'Nécessite une révision', value: 'revision'},
        ]
    },

    get_type_choices() {
        return [
            {text: 'SaaS', value: 'saas'},
            {text: 'Bureau', value: 'desk'},
            {text: 'Mobile', value: 'mobile'},
        ]
    }
}

const SoftwareInstallation = {
    ...service('software-installations'),
    get_form() {
        return {
            date: null,
            departement: null,
            software: null,
            tool: null,
            version: null,
        }
    }
}

const SoftwareLicence = {
    ...service('software-licences'),
    get_form() {
        return {
            name: null,
            type: null,
            key: null,
        }
    }
}

const SoftwareUser = {
    ...service('software-users'),
    get_form() {
        return {
            assigned_date: null,
            departement: null,
            licence: null,
            name: null,
            software: null,
            source: null,
        }
    }
}

const Solutions = {
    ...service('solutions'),
    get_form() {
        return {
            autor: null,
            file: null,
            inserted_in_tickets: null,
            items: null,
            not_useful: null,
            status: null,
            useful: null,
            views: null,
            title: null,
            description: null,
            type:null,
            revision_date:null,
            keywords:[],
        }
    },

    get_status_choices(){
        return [
            {value: "drafts", text: "Brouillon"},
            {value: "publish", text: "Publié"},
        ]
    },

    get_type_choices(){
        return [
            {value: "circumvention", text: "Solution de contournement"},
            {value: "permanent", text: "Solution permanente"},
        ]
    }
}

const SolutionCategory = {
    ...service('solution-categories'),
    get_form() {
        return {
            name: null,
            description: null,
            solution: null,
        }
    }
}

const Source = {
  ...service('sources'),
  get_form() {
    return {
      name: null,
      is_active: true,
    }
  },
}

const SubCategory = {
    ...service('sub-categories'),
    get_form() {
        return {
            category: null,
            name: null,
        }
    }
}

const SubCategoryQuestion = {
    ...service('sub-category-questions'),
    get_form() {
        return {
            category_question: null,
            name: null,
        }
    }
}

const Task = {
    ...service('tasks'),
    get_form() {
        return {
            assignment: null,
            deadline: null,
            description: null,
            name: null,
            ticket: null,
            priority: 'low',
            remind: null,
            repeat: null,
            unit: null,
            value: null,
            never: true,
            date: null,
            after: null,
            validate: false,
            remindDate: null,
            before: null,
            beforeUnit: null,
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
        }
    },
    get_days_week() {
        return [
            {text: 'Lundi', value: 'monday'},
            {text: 'Mardi', value: 'tuesday'},
            {text: 'Mercredi', value: 'wednesday'},
            {text: 'Jeudi', value: 'thursday'},
            {text: 'Vendredi', value: 'friday'},
            {text: 'Samedi', value: 'saturday'},
            {text: 'Dimanche', value: 'sunday'},
        ]
    },
    get_priorities_choices() {
        return [
            {text: 'Faible', value: 'low'},
            {text: 'Moyenne', value: 'average'},
            {text: 'Forte', value: 'high'},
        ]
    },
    get_remind_choices() {
        return [
            {text: 'Activé', value: true},
            {text: 'Désactivé', value: false},
        ]
    },
    get_repeat_choices() {
        return [
            {text: 'Une seule fois', value: 'once'},
            {text: 'Tous les jours', value: 'everyday'},
            {text: 'Toute les semaines le lundi', value: 'everyweek'},
            {text: 'Tous les mois le premier lundi', value: 'everymonth'},
            {text: 'Tous les ans le 2 août', value: 'everyyear'},
            {text: 'Du lundi au vendredi', value: 'week'},
            {text: 'Personaliser...', value: 'personalize'},
        ]
    },
    get_unit_choices() {
        return [
            {text: 'jour(s)', value: 'day'},
            {text: 'semaine(s)', value: 'week'},
            {text: 'mois', value: 'month'},
            {text: 'année(s)', value: 'year'},
        ]
    },
    get_before_unit_choices() {
        return [
            {text: 'minutes', value: 'minute'},
            {text: 'hours', value: 'hour'},
            {text: 'jour(s)', value: 'day'},
            {text: 'semaine(s)', value: 'week'},
        ]
    },
}

const Time = {
    ...service('times'),
    get_form() {
        return {
            assignment: null,
            time_pass: null,
            description: null,
            date: null,
            ticket: null,
            billable: false,
        }
    }
}

const Ticket = {
    ...service('tickets'),
    get_form() {
        return {
            assigned_to: null,
            client: null,
            impact: null,
            is_active: true,
            priority: null,
            reference: null,
            solution: [],
            step: null,
            status: null,
            subject: null,
            sub_category: null,
            tool: [],
            source: null,
            deadline: null,
        }
    },

    get_status_choices() {
        return [
            {text: 'Ouvert', value: 'open'},
            {text: 'En attente', value: 'waiting'},
            {text: 'Résolu', value: 'solved'},
            {text: 'Fermé', value: 'closed'},
        ]
    },

    get_priorities_choices() {
        return [
            {text: 'Faible', value: 'low'},
            {text: 'Moyenne', value: 'average'},
            {text: 'Élevée', value: 'high'},
            {text: 'Urgence', value: 'emergency'},
        ]
    },

    get_impacts_choices() {
        return [
            {text: 'Faible', value: 'low'},
            {text: 'Moyenne', value: 'average'},
            {text: 'Élevée', value: 'high'},
        ]
    },
    get_source_choices() {
        return [
            { text: 'Chat', value: 'chat' },
            { text: 'Email', value: 'mail' },
            { text: 'Portail', value: 'portal' },
            { text: 'Site internet', value: 'website' },
        ]
    },
    get_step_choices() {
        return [
            {text: "En retard", value: "late", color: "danger"},
            {text: "Réponse requise", value: "emergency", colo: "warning"},
            {text: "À l'heure", value: "in_time", color: "success"},
        ]
    },
}

const TicketExternal = {
    ...service('ticket-externals'),
    get_form() {
        return {
            assigned_to: null,
            first_name: null,
            impact: null,
            last_name: null,
            mail: null,
            priority: null,
            reference: null,
            solution: [],
            step: null,
            subject: null,
            sub_category: null,
            tool: [],
            type: null,
            source: null,
        }
    },

    get_status_choices() {
        return [
            {text: 'Ouvert', value: 'open', color: 'success'},
            {text: 'En attente', value: 'waiting', color: 'warning'},
            {text: 'Résolu', value: 'solved', color: 'primary'},
            {text: 'Fermé', value: 'closed', color: 'danger'},
        ]
    },

    get_priorities_choices() {
        return [
            {text: 'Faible', value: 'low', color: 'success'},
            {text: 'Moyenne', value: 'average', color: 'warning'},
            {text: 'Élevée', value: 'high', color: 'primary'},
            {text: 'Urgence', value: 'emergency', color: 'danger'},
        ]
    },

    get_impacts_choices() {
        return [
            {text: 'Faible', value: 'low', color: 'success'},
            {text: 'Moyenne', value: 'average', color: 'warning'},
            {text: 'Élevée', value: 'high', color: 'danger'},
        ]
    },

    get_step_choices() {
        return [
            {text: "En retard", value: "late", color: "danger"},
            {text: "Réponse requise", value: "emergency", colo: "warning"},
            {text: "À l'heure", value: "in_time", color: "success"},
        ]
    },

    get_type_choices() {
        return [
            {value: 'incident', text: 'Incident'},
            {value: 'problem', text: 'Problème'},
            {value: 'question', text: 'Question'},
            {value: 'fonctionality', text: 'Demande de fonctionnalité'},
            {value: 'order', text: 'Commande'},
            {value: 'return_refund', text: 'Retour & remboursement'},
        ]
    },

    get_type_abbreviation_choices(){
        return[
            {value: 'incident', text: 'INC'},
            {value: 'problem', text: 'PRB'},
            {value: 'question', text: 'QUEST'},
            {value: 'fonctionality', text: 'FONCT'},
            {value: 'order', text: 'CMDE'},
            {value: 'return_refund', text: 'BACK'},
        ]
    },

    public(data){
        return this.request({method: 'POST', url: `${this.url}public/`, data})
    },
    list_public(organization){
        return this.request({method: 'GET', url: `${this.url}public/${organization}`})
    },
}

const TicketInternal = {
    ...service('ticket-internals'),
    get_form() {
        return {
            assigned_to: null,
            client: null,
            impact: null,
            priority: null,
            reference: null,
            solution: [],
            step: null,
            status: null,
            subject: null,
            tool: [],
            type: null,
            source: null,
        }
    },

    get_status_choices() {
        return [
            {text: 'Ouvert', value: 'open', color: 'success'},
            {text: 'En attente', value: 'waiting', color: 'warning'},
            {text: 'Résolu', value: 'solved', color: 'primary'},
            {text: 'Fermé', value: 'closed', color: 'danger'},
        ]
    },

    get_priorities_choices() {
        return [
            {text: 'Faible', value: 'low', color: 'success'},
            {text: 'Moyenne', value: 'average', color: 'warning'},
            {text: 'Élevée', value: 'high', color: 'primary'},
            {text: 'Urgence', value: 'emergency', color: 'danger'},
        ]
    },

    get_impacts_choices() {
        return [
            {text: 'Faible', value: 'low', color: 'success'},
            {text: 'Moyenne', value: 'average', color: 'warning'},
            {text: 'Élevée', value: 'high', color: 'danger'},
        ]
    },

    get_step_choices() {
        return [
            {text: "En retard", value: "late", color: "danger"},
            {text: "Réponse requise", value: "emergency", colo: "warning"},
            {text: "À l'heure", value: "in_time", color: "success"},
        ]
    },

    get_type_choices() {
        return [
            {value: 'incident', text: 'Incident'},
            {value: 'problem', text: 'Problème'},
            {value: 'changement', text: 'Changement'},
        ]
    },

    get_type_abbreviation_choices(){
        return[
            {value: 'incident', text: 'INC'},
            {value: 'problem', text: 'PRB'},
            {value: 'changement', text: 'CHNG'},
        ]
    },
}

const Timeline = {
    ...service('timelines'),
    get_form() {
        return {
            agent: null,
            billable: false,
            date: null,
            task: null,
            time_spent: null,
        }
    }
}

const ToolCategory = {
    ...service('tool-categories'),
    get_form() {
        return {
            name: null,
            parents: [],
            tool: null,
        }
    }
}

const Tool = {
    ...service('tools'),
    get_form() {
        return {
            departement: null,
            description: null,
            impact: null,
            location: null,
            managed_by: null,
            name: null,
            reference: null,
            tickets: [],
            type: null,
            usage: null,
            used_by: [],
        }
    },

    get_impacts_choices() {
        return [
            {text: 'Faible', value:'low'},
            {text: 'Moyenne', value:'average'},
            {text: 'Élevée', value:'high'},
        ]
    },

    get_type_choices() {
        return [
            {value: 'business_service', text: 'Business service', obj: ToolBusinessService},
            {value: 'sales_department', text: 'Service des ventes', obj: ToolBusinessService},
            {value: 'help_desk', text: 'Service d\'assistance', obj: ToolBusinessService},
            {value: 'it_service', text: 'IT Service', obj: ToolServiceIt},
            {value: 'messaging_service', text: 'Service de messagerie', obj: ToolServiceIt},
            {value: 'backup_service', text: 'Service de sauvegarde', obj: ToolServiceIt},
            {value: 'hosting_service', text: 'Service d\'hébergement', obj: ToolServiceIt},
            {value: 'aws', text: 'AWS', obj: ToolCloud},
            {value: 'ec2', text: 'EC2', obj: ToolCloud},
            {value: 'rds', text: 'RDS', obj: ToolCloud},
            {value: 'ebs', text: 'EBS', obj: ToolCloud},
            {value: 'computer', text: 'Ordinateur', obj: ToolComputer},
            {value: 'desktop', text: 'Ordinateur de bureau', obj: ToolComputer},
            {value: 'laptop', text: 'Ordinateur portable', obj: ToolComputer},
            {value: 'server', text: 'Serveur', obj: ToolComputer},
            {value: 'server_unix', text: 'Serveur Unix', obj: ToolComputer},
            {value: 'server_aix', text: 'Serveur Aix', obj: ToolComputer},
            {value: 'server_solaris', text: 'Serveur Solaris', obj: ToolComputer},
            {value: 'server_wmware', text: 'Serveur WMware', obj: ToolComputer},
            {value: 'server_windows', text: 'Serveur Windows', obj: ToolComputer},
            {value: 'storage', text: 'Stockage', obj: ToolHardware},
            {value: 'disk', text: 'Disque', obj: ToolDisk},
            {value: 'data_center', text: 'Data Center', obj: ToolHardware},
            {value: 'rack', text: 'Rack', obj: ToolRack},
            {value: 'ups', text: 'UPS', obj: ToolUps},
            {value: 'mobile_devices', text: 'Apareils mobiles', obj: ToolHardware},
            {value: 'phone', text: 'Téléphone', obj: ToolPhone},
            {value: 'tablet', text: 'Tablette', obj: ToolTablet},
            {value: 'screen', text: 'Ecran', obj: ToolHardware},
            {value: 'printer', text: 'Imprimante', obj: ToolPrinter},
            {value: 'projector', text: 'Projecteur', obj: ToolHardware},
            {value: 'scanner', text: 'Scanner', obj: ToolHardware},
            {value: 'router', text: 'Routeur', obj: ToolRouter},
            {value: 'switch', text: 'Switch (commutateur)', obj: ToolRouter},
            {value: 'wifi_access', text: 'Point d\'accès WiFi (WLAN)', obj: ToolRouter},
            {value: 'firewall', text: 'Pare-feu', obj: ToolRouter},
            {value: 'other_devices', text: 'Autres appareils', obj: ToolHardware},
            {value: 'snmp', text: 'SNMP', obj: ToolSnmp},
            {value: 'network', text: 'Réseau', obj: ToolNetwork},
            {value: 'other', text: 'Autres', obj: ToolOther},
        ]
    },

    get_tool_type() {
        return [
            {value: 'business_service', text: 'Business Service'},
            {value: 'it_service', text: 'IT Service'},
            {value: 'aws', text: 'AWS'},
            {value: 'computer', text: 'Ordinateur'},
            {value: 'server', text: 'Serveur'},
            {value: 'stock', text: 'Stockage'},
        ]
    },

    get_usage_choices() {
        return [
            {text: 'Permanente', value: 'perm'},
            {text: 'En prêt', value: 'loan'},
        ]
    }
}

const ToolBusinessService = {
  ...service('tool-business-services'),
  get_form() {
    return {
      ...Tool.get_form(),
      sla: null,
      cost: null,
      resourcetype: 'ToolPropertyBusinessService',
    }
  }
}

const ToolCloud = {
  ...service('tool-clouds'),
  get_form() {
    return {
      ...Tool.get_form(),
      last_audit: null,
      cost: null,
      resourcetype: 'ToolPropertyCloud',
    }
  }
}

const ToolComputer = {
    ...service('tool-computers'),
    get_form() {
        return {
            ...ToolHardware.get_form(),
            adress_IP: null,
            adress_MAC: null,
            disk_space: null,
            host_name: null,
            last_connection_by: null,
            memory: null,
            operating_system: null,
            processor_core_number: null,
            processor_speed: null,
            service_pack: null,
            UUID: null,
            version: null,
            resourcetype: 'ToolPropertyComputer',
        }
    },

    get_operating_system_choices() {
        return [
            {text: 'Aix', value: 'aix'},
            {text: 'Solaris', value: 'solaris'},
            {text: 'Mac', value: 'mac'},
            {text: 'Linux', value: 'linux'},
            {text: 'Windows', value: 'windows'},
        ]
    },
}

const ToolDisk = {
    ...service('tool-disks'),
    get_form() {
        return {
          ...ToolHardware.get_form(),
            checked: null,
            disk_space: null,
            disk_type: null,
            free_space: null,
            resourcetype: 'ToolPropertyDisk',
        }
    },

    get_disk_type_choices() {
        return [
            {value: 'cd', text: 'CD ROM/RW'},
            {value: 'dvd', text: 'DVD'},
            {value: 'logical_drive', text: 'Logical Drive'},
            {value: 'nfs', text: 'NFS'},
            {value: 'other', text: 'Autre'}
        ]
    },
}

const ToolExpense = {
  ...service('tool-expenses'),
  get_form() {
    return {
      cost: null,
      date: null,
      description: null,
      tool: null,
      type: null,
    }
  },

  get_type_choices() {
    return [
      { text: 'Coût de maintenance', value: 'maintenance' },
      { text: 'Coût de support', value: 'help' },
      { text: "Coût d'élimination", value: 'disposal' },
      { text: 'Autre', value: 'other' },
    ]
  }
}

const ToolHardware = {
  ...service('tool-hardwares'),
  get_form() {
    return {
      ...Tool.get_form(),
      acquisition: null,
      expiration: null,
      guarantee: null,
      last_audit: null,
      provider: null,
      serial_number: null,
      shock_absorber: null,
      status: null,
      recover: null,
      cost: null,
      resourcetype: 'ToolPropertyHardware',
    }
  },

  get_status_choices() {
      return [
        {value: 'used', text: 'Utilisé'},
        {value: 'missing', text: 'Manquant'},
        {value: 'transit', text: 'En transit'},
        {value: 'stock', text: 'En stock'},
        {value: 'removed', text: 'Retiré'},
        {value: 'reserved', text: 'Réservé'},
      ]
  },

  get_absorber_choices() {
    return [
      {text: 'DB-5', value:'db'},
      {text: 'SL-5', value:'sl'},
      {text: 'SYD-5', value:'syd'},
    ]
  }
}

const ToolNetwork = {
    ...service('tool-networks'),
    get_form() {
        return {
            ...Tool.get_form(),
            bandwidth: null,
            network_reach: null,
            resourcetype: 'ToolPropertyNetwork',
        }
    }
}

const ToolOther = {
    ...service('tool-others'),
    get_form() {
        return {
            ...Tool.get_form(),
            resourcetype: 'ToolPropertyOther',
        }
    },

    get_impacts_choices() {
        return [
            {text: 'Faible', value: 'low'},
            {text: 'Moyenne', value: 'medium'},
            {text: 'Élevée', value: 'hight'},
        ]
    },

    get_type_choices() {
        return [
            {value: 'service', text: 'Service'},
            {value: 'business_service', text: 'Business service'},
            {value: 'sales_department', text: 'Service des ventes'},
            {value: 'help_desk', text: "Service d'assistance"},
            {value: 'messaging_service', text: 'Service de messagerie'},
            {value: 'backup_service', text: 'Service de sauvegarde'},
            {value: 'hosting_service', text: "Service d'hébergement"},
            {value: 'cloud', text: 'Cloud'},
            {value: 'aws', text: 'AWS'},
            {value: 'ec2', text: 'EC2'},
            {value: 'rds', text: 'RDS'},
            {value: 'ebs', text: 'EBS'},
            {value: 'hardware', text: 'Hardware'},
            {value: 'computer', text: 'Ordinateur'},
            {value: 'desktop', text: 'Ordinateur de bureau'},
            {value: 'laptop', text: 'Ordinateur portable'},
            {value: 'server', text: 'Serveur'},
            {value: 'server_unix', text: 'Serveur Unix'},
            {value: 'server_aix', text: 'Serveur Aix'},
            {value: 'server_solaris', text: 'Serveur Solaris'},
            {value: 'server_wmware', text: 'Serveur WMware'},
            {value: 'server_windows', text: 'Serveur Windows'},
            {value: 'storage', text: 'Stockage'},
            {value: 'disk', text: 'Disque'},
            {value: 'data_center', text: 'Data Center'},
            {value: 'rack', text: 'Rack'},
            {value: 'ups', text: 'UPS'},
            {value: 'mobile_apareils', text: 'Apareils mobiles'},
            {value: 'phone', text: 'Téléphone'},
            {value: 'tablet', text: 'Tablette'},
            {value: 'screen', text: 'Ecran'},
            {value: 'printer', text: 'Imprimante'},
            {value: 'projector', text: 'Projecteur'},
            {value: 'router', text: 'Routeur'},
            {value: 'switch', text: 'Switch (commutateur)'},
            {value: 'wifi_access', text: "Point d'accès WiFi (WLAN)"},
            {value: 'firewall', text: 'Pare-feu'},
            {value: 'other_devices', text: 'Autres appareils'},
            {value: 'snmp', text: 'SNMP'},
            {value: 'network', text: 'Réseau'},
            {value: 'other', text: 'Autres'},
        ]
    }
}

const ToolPhone = {
    ...service('tool-phones'),
    get_form() {
        return {
          ...ToolHardware.get_form(),
            memory: null,
            number_imei: null,
            operating_system: null,
            version: null,
            resourcetype: 'ToolPropertyPhone',
        }
    },

    get_operating_system_choices() {
        return [
            {value: 'ios', text: 'IOS 7'},
            {value: 'android', text: 'Android 4.4'},
            {value: 'blackberry', text: 'Blackberry'},
            {value: 'symbian', text: 'Synbian'},
            {value: 'windows', text: 'Windows Phone'},
        ]
    },
}

const ToolPrinter = {
    ...service('tool-printers'),
    get_form() {
        return {
            ...ToolHardware.get_form(),
            adress_IP: null,
            adress_MAC: null,
            operating_system: null,
            subnet_mask: null,
            resourcetype: 'ToolPropertyPrinter',
        }
    },

    get_operating_system_choices() {
        return [
            {value: 'laser', text: 'Laser'},
            {value: 'dot_matrix', text: 'Dot Matrix'},
            {value: 'inkjet', text: 'InkJet'},
            {value: 'other', text: 'Autre'}
        ]
    },
}

const ToolRack = {
    ...service('tool-racks'),
    get_form() {
        return {
          ...ToolHardware.get_form(),
            baies: null,
            berries_used: null,
            energy_consumption: null,
            footprint: null,
            resourcetype: 'ToolPropertyRack',
        }
    },
}

const ToolRelation = {
  ...service('tool-relations'),
  get_form() {
    return {
      origin: null,
      target: null,
      relation: null,
    }
  },

  get_relation_choices() {
    return [
      {text: 'Dépend de', value: 'depend_of'},
      {text: 'Utilise', value: 'use'},
      {text: 'Envoie des données à', value: 'send_data_to'},
      {text: 'Fonctionne sur', value: 'work_on'},
      {text: 'Connecté à', value: 'connect_to'},
      {text: 'Souscrit à', value: 'subscribed_to'},
      {text: 'Impacté par', value: 'impact_by'},
      {text: 'Soumis par', value: 'submitted_by'},
      {text: 'Supporté par', value: 'support_by'},
      {text: 'Auteur de', value: 'made_by'},
      {text: 'Hébergé sur', value: 'host_by'},
      {text: 'Est activé par', value: 'actived_by'},
      {text: 'Contenu dans', value: 'inside'},
      {text: 'Échange des données avec', value: 'exchange_with'},
      {text: 'Dirige', value: 'lead'},
      {text: 'Édite', value: 'edit'},
      {text: 'Soutient', value: 'sustain'},
      {text: 'Contient', value: 'have'},
      {text: 'Sauvegarde', value: 'save'},
      {text: 'Est permis par', value: 'allow_by'},
    ]
  }
}

const ToolRouter = {
    ...service('tool-routers'),
    get_form() {
        return {
            ...ToolHardware.get_form(),
            adress_IP: null,
            adress_MAC: null,
            firmware: null,
            ports: null,
            subnet_mask: null,
            version: null,
            resourcetype: 'ToolPropertyRouter',
        }
    },
}

const ToolService = {
    ...service('tool-services'),
    get_form() {
        return {
          ...Tool.get_form(),
          resourcetype: 'ToolPropertyService',
        }
    },
}

const ToolServiceIt = {
    ...service('tool-service-it'),
    get_form() {
        return {
            ...Tool.get_form(),
            cost: null,
            opening_hours: null,
            sla: null,
            resourcetype: 'ToolPropertyServiceIt',
        }
    }
}

const ToolSnmp = {
    ...service('tool-snmp'),
    get_form() {
        return {
            ...ToolHardware.get_form(),
            adress_MAC: null,
            oid_system: null,
            resourcetype: 'ToolPropertySnmp',
        }
    },
}

const ToolTablet = {
    ...service('tool-tablets'),
    get_form() {
        return {
            ...ToolHardware.get_form(),
            memory: null,
            operating_system: null,
            version: null,
            resourcetype: 'ToolPropertyTablet',
        }
    },

    get_operating_system_choices() {
        return [
            {value: 'ios', text: 'IOS 7'},
            {value: 'android', text: 'Android 4.4'},
            {value: 'blackberry', text: 'Blackberry'},
            {value: 'symbian', text: 'Synbian'},
            {value: 'windows', text: 'Windows Phone'},
        ]
    },
}

const ToolUps = {
    ...service('tool-ups'),
    get_form() {
        return {
            ...ToolHardware.get_form(),
            adress_IP: null,
            battery_current: null,
            battery_status: null,
            battery_voltage: null,
            resourcetype: 'ToolPropertyUps',
        }
    },

    get_battery_status_choices() {
        return [
            {value: 'good', text: 'Bon'},
            {value: 'normal', text: 'Normal'},
            {value: 'bad', text: 'Mauvais'},
        ]
    }
}

module.exports = {
    Answer,
    Contract,
    Category,
    CategoryQuestion,
    Charge,
    Component,
    Cost,
    CostItem,
    License,
    Note,
    Question,
    Reference,
    Sla,
    SlaAnswerRule,
    SlaEmailAlert,
    SlaResolutionRule,
    SlaRule,
    SlaTicketDelayRule,
    SlaTicketRule,
    Software,
    SoftwareInstallation,
    SoftwareLicence,
    SoftwareUser,
    Solutions,
    SolutionCategory,
    Source,
    SubCategory,
    SubCategoryQuestion,
    Task,
    Time,
    Ticket,
    TicketExternal,
    TicketInternal,
    Timeline,
    Tool,
    ToolCategory,
    ToolBusinessService,
    ToolCloud,
    ToolComputer,
    ToolDisk,
    ToolExpense,
    ToolHardware,
    ToolNetwork,
    ToolOther,
    ToolPhone,
    ToolPrinter,
    ToolRack,
    ToolRelation,
    ToolRouter,
    ToolServiceIt,
    ToolService,
    ToolSnmp,
    ToolTablet,
    ToolUps,
}
